import React, { Component } from 'react'
import { VALIDATE } from './style'
export class Validate extends Component {
  render () {
    const {
      text,
      className = ''
    } = this.props
    return (
      text !== '' &&
        <VALIDATE className={className}>
          {text}
        </VALIDATE>
    )
  }
}
